import { render, staticRenderFns } from "./for-review.page.vue?vue&type=template&id=76c5ec23&scoped=true&"
import script from "./for-review.page.vue?vue&type=script&lang=js&"
export * from "./for-review.page.vue?vue&type=script&lang=js&"
import style0 from "./for-review.page.vue?vue&type=style&index=0&id=76c5ec23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c5ec23",
  null
  
)

export default component.exports